var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(this.isVisible)?_c('button',{staticClass:"back-button",on:{"click":_vm.scrollToTop}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }